import { createSlice } from "@reduxjs/toolkit";
import { Log } from "types/Log";

interface logSlice {
  logs: Log[];
  log: Log;
}


// Define the initial state using that type
const initialState: logSlice = {
  logs: [],
  log: null,
};


export const logSlice = createSlice({
  name: "logs",
  initialState: initialState,
  reducers: {
    addLogs: (state, action) => {
      state.logs = action.payload;
    },
    insertLog: (state, action) => {
      state.logs = [
        ...state.logs.slice(0, action.payload),
        action.payload,
        ...state.logs.slice(action.payload)
      ]
    },
    removeLog: (state, action) => {
      state.logs = [...state.logs.slice(0, action.payload), ...state.logs.slice(action.payload + 1)]
    },
    updateLog: (state, action) => {
      state.logs = state.logs.map((item) =>  item.id !== action.payload.id ? item : { ...item, ...action.payload.item })
    
    }  
  },
});

export const { insertLog, removeLog, updateLog, addLogs } = logSlice.actions;
export default logSlice.reducer;